'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('ColorRequest', ['$resource', '$stateParams', 'apiSettings', '$http', function ($resource, $stateParams, apiSettings, $http) {
    var ColorRequest = $resource(apiSettings.baseUri + 'v1/colorsrequests/:id', { id: '@id' }, {
        'list': {
            method: 'GET',
            isArray: false,
            params: {
                page: 1,
                pageSize: apiSettings.defaultPageSize
            }
        },
        'listIds': {
            url: apiSettings.baseUri + 'v1/colorsrequests/list/ids',
            method: 'GET',
            isArray: true
        },
        'listCustomersIds': {
            url: apiSettings.baseUri + 'v1/customers/list/ids',
            method: 'GET',
            isArray: true,
            params: {
                keyword: null
            }
        },
        'insert': {
            method: 'POST'
        },
        'update': {
            method: 'PUT'
        },
        'delete': {
            method: 'DELETE'
        },
        'classificationsTypes': {
            url: apiSettings.baseUri + 'v1/enumerators/classificationstypes',
            method: 'GET',
            isArray: true
        },
        'projectsTypes': {
            url: apiSettings.baseUri + 'v1/enumerators/projectstypes',
            method: 'GET',
            isArray: true
        },
        'verifyCustomer': {
            url: apiSettings.baseUri + 'v1/colorsrequests/verify-customers/:customerId',
            method: 'GET',
            isArray: false
        },
        'insertSale': {
            url: apiSettings.baseUri + 'v1/sales',
            method: 'POST'
        },
        'listSales': {
            url: apiSettings.baseUri + 'v1/sales/list/:colorsRequestId',
            method: 'GET'
        },
        'saleGet': {
            url: apiSettings.baseUri + 'v1/sales/:saleId',
            method: 'GET',
            isArray: false
        },
        'deleteSale': {
            url: apiSettings.baseUri + 'v1/sales/:saleId',
            method: 'DELETE'
        },
        'dash': {
            method: 'GET',
            isArray: false,
            url: apiSettings.baseUri + 'v1/colorsrequests/dash',
        },
        'dashboardCommercial': {
            method: 'GET',
            isArray: false,
            url: apiSettings.baseUri + 'v1/colorsrequests/dashboard/commercial',
        },
        'dashboardOperational': {
            method: 'GET',
            isArray: false,
            url: apiSettings.baseUri + 'v1/colorsrequests/dashboard/operational',
        },
        'dashboardDesigners': {
            method: 'GET',
            isArray: false,
            url: apiSettings.baseUri + 'v1/colorsrequests/dashboard/designers',
        },
        'dashboardSegmentation': {
            method: 'GET',
            isArray: false,
            url: apiSettings.baseUri + 'v1/colorsrequests/dashboard/segmentation',
        },
        'deleteColor': {
            url: apiSettings.baseUri + 'v1/colorsrequests/deleteColor/:colorsRequestId',
            method: 'DELETE',
            isArray: false
        },
        'nationalHolidays': {
            url: 'https://brasilapi.com.br/api/feriados/v1/:year',
            method: 'GET',
            isArray: true
        },
        'insertExternal': {
            url: apiSettings.baseUri + 'v1/colorsrequests/external',
            method: 'POST'
        },
    });

    ColorRequest.insertExternal = function (payload) {
        return $http({
            method: 'POST',
            url: apiSettings.baseUri + 'v1/colorsrequests/external',
            data: payload
        })
            .then(function (response) {
                var idColorRequest = parseInt(response.data, 10);
                return idColorRequest;
            })
            .catch(function (error) {
                throw error;
            });
    }

    return ColorRequest;
}]);